import { FC } from 'react';

interface ImageProps {
  optimized: {
    small: string;
    medium: string;
    large: string;
  };
  src: string;
  alt?: string;
  title?: string;
  // or create custom REST type and extend
  className?: string;
  onClick?: () => void;
}

export const ImageNoCaption: FC<ImageProps> = ({ optimized, title = '', alt = '', src, ...props }) => {
  return (
      <picture className={"w-full h-full"}>
        <source media="(max-width: 450px)" srcSet={optimized?.small} />
        <source media="(max-width: 893px)" srcSet={optimized?.medium} />
        <source media="(max-width: 1728px)" srcSet={optimized?.large} />
        <img {...props} src={src} alt={title || alt} />
      </picture>
  );
};

export const Image: FC<ImageProps> = ({ optimized, title = '', alt = '', src, ...props }) => {
  return (
    <figure className={title ? "relative w-full h-full": ""}>
      <picture className={title ? "relative w-full h-full": "relative"}>
        <source media="(max-width: 450px)" srcSet={optimized?.small} />
        <source media="(max-width: 893px)" srcSet={optimized?.medium} />
        <source media="(max-width: 1728px)" srcSet={optimized?.large} />
        <img {...props} src={src} alt={title || alt} />
      </picture>
      {title && (
        <figcaption className="absolute bottom-0 left-0 w-full pb-[var(--gap)] text-center">
          <span className="inline-block rounded-[35px] bg-gray-900 px-[10%] py-[2%]">{title}</span>
        </figcaption>
      )}
    </figure>
  );
};
